<au-expansion-panel [panelCanBeExpanded]="!!images?.length" [expanded]="isPanelOpen">
	<ng-container panel-title>
		<span class="section-name">{{ 'images' | translate }}</span>
		@if (images?.length) {
			<span class="circle-container">{{ images?.length }} </span>
		}
	</ng-container>

	<ng-container panel-description>
		<button mat-mini-fab class="surface-fab" (click)="attachImage($event)">
			<mat-icon svgIcon="add"></mat-icon>
		</button>
	</ng-container>

	<ng-container panel-content>
		<div class="images-container">
			@for (image of images; track image; let i = $index) {
				<div class="image-sections">
					<img [src]="image?.file?.url" alt="img" (click)="openImage(i)" />
				</div>
			}
		</div>
	</ng-container>
</au-expansion-panel>
